import type { PathObjectInterface } from '@/map-phaser-new/interfaces'

export const carBottomRightToLeftPath: PathObjectInterface = {
  mainPath: { x: 1663, y: 1322 },
  spline: [
    1663, 1322, 1701, 1372, 1723, 1405, 1692, 1441, 1579, 1482, 1548, 1504, 1516, 1549, 1485, 1600,
    1452, 1643, 1363, 1667, 1288, 1669, 1212, 1662, 1125, 1643, 1058, 1624, 1005, 1597, 904, 1530,
  ],
}
